import Mustache from 'mustache';
import { optional } from '../Imports/Helpers';
export class Aggregation {
    constructor(options = {}) {
        /**
         * @type {string} A custom template for the aggregation, if not set a default will be used
         */
        this.template = null;
        /**
         * The values that are set for the aggregation
         */
        this.values = {};
        /**
         * The value sent to the search
         */
        this.value = {};
        /**
         * Is the item collapsible or not
         */
        this.collapsible = false;
        /**
         * Is the item default collapsed
         */
        this.defaultCollapsed = false;
        this.hasActiveAggregation = true;
        this.useSkeleton = null;
        this.setTitle(options.title || '');
        this.setClassTitle(this.getTitle() || '');
        this.setTemplate(options.template || '');
        this.setAttribute(options.attribute || this.getTitle());
        this.setCollapsible(options.collapsible || this.getCollapsible());
        this.setDefaultCollapsed(options.default_collapsed || this.getDefaultCollapsed());
        this.setUseSkeleton((typeof optional(options).use_skeleton !== 'undefined') ?
            optional(options).use_skeleton : this.getUseSkeleton());
        this.setSkeletonTemplate(optional(options).skeleton_template || this.getSkeletonTemplate());
    }
    getUseSkeleton() {
        if (this.useSkeleton === null && this.parent) {
            return this.parent.getUseSkeleton();
        }
        return this.useSkeleton;
    }
    setUseSkeleton(useSkeleton) {
        this.useSkeleton = useSkeleton;
        return this;
    }
    setSkeletonTemplate(template) {
        this.skeletonTemplate = template;
        return this;
    }
    getSkeletonTemplate() {
        return this.skeletonTemplate;
    }
    renderSkeleton() {
        const rendered = Mustache.render(this.getSkeletonTemplate(), {
            class_title: this.getClassTitle(),
        });
        return rendered;
    }
    setClassTitle(classTitle) {
        this.classTitle = classTitle.replace(/ /g, '-');
        return this;
    }
    getClassTitle() {
        return this.classTitle;
    }
    setAttribute(attribute) {
        this.attribute = attribute;
        if (!this.value.field) {
            this.value = {
                field: this.attribute,
                value: '',
                is_aggregation: true,
                exclude_from_search: true,
            };
        }
        return this;
    }
    getAttribute() {
        return this.attribute;
    }
    setCollapsible(collapsible) {
        this.collapsible = collapsible;
        return this;
    }
    getCollapsible() {
        return this.collapsible;
    }
    setDefaultCollapsed(defaultCollapsed) {
        this.defaultCollapsed = defaultCollapsed;
        return this;
    }
    getDefaultCollapsed() {
        return this.defaultCollapsed;
    }
    setTitle(title) {
        this.title = title;
        this.setClassTitle(this.title);
        return this;
    }
    getTitle() {
        return this.title;
    }
    setTemplate(template) {
        this.template = template;
        return this;
    }
    getTemplate() {
        return this.template;
    }
    /**
     * This function will be used to render the HTML
     * This is done by using Mustache-JS
     * @return {string}
     */
    render() {
        return this.getTemplate();
    }
    /**
     * The after load Javascript, used for event listeners etc.
     */
    executeJS() {
    }
    reset() {
    }
}
